import { render, staticRenderFns } from "./GlobalNav.vue?vue&type=template&id=8cf4dfce&"
import script from "./GlobalNav.vue?vue&type=script&lang=js&"
export * from "./GlobalNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports